<template>
  <panel-main-template>
    <template v-slot:page-title>Запись онлайн</template>
    <template v-slot:page-content>
      <div class="integrate--container">

        <div class="integrate--links shadow-card width-100p mrg-t-10">
          <div class="text-bold">Компании и ссылки на запись онлайн:</div>
          <div class="companies mrg-t-10">
            <div class="item" v-for="item in links.companies" :key="item.id">
              <div class="img">
                <img :src="item.image">
              </div>
              <div class="info">
                <div class="name">{{item.name}}</div>
                <div class="address">{{item.address}}</div>
                <div class="city">{{item.city}}</div>
                <div class="link text-link mrg-t-10">
                  <a
                      :href="item.link"
                      target="_blank"
                      :id="'copy_link' +item.id"
                  ><b>{{item.link}}</b>
                  </a>
                </div>
                <div class="actions mrg-t-10">
                  <div @click="copyText(item.link)" class="btn btn-sm btn-orange">Скопировать</div>
                  <div @click="diagnostics(item.id)" class="btn btn-sm btn-success">Диагностика</div>
                </div>
              </div>
            </div>
            <div v-if="links.companies.length === 0 && requestCount > 0">
              <div class="alert alert-sm alert-danger">
                Нет ни одной компании. Перейдите в раздел "Компании/Филиалы" и создайте первую компанию
              </div>
            </div>
          </div>
        </div>

        <div v-if="links.common" class="integrate--common width-100p shadow-card mrg-t-10">
          <div class="text-bold">Общая ссылка на все филиалы</div>
          <div class="link text-link mrg-t-10">
            <a
              :href="links.common"
              target="_blank"
              id="copy_link_common"
            >
              <b>{{links.common}}</b>
            </a>
          </div>
          <div class="actions mrg-t-10">
            <div @click="copyText(links.common)" class="btn btn-sm btn-orange">Скопировать</div>
          </div>
        </div>

        <div class="integrate--freelance width-100p shadow-card mrg-t-10">
          <div class="text-bold">Помощь в интеграции</div>
          <div class="mrg-t-10">
            <p>
              Мы можем предоставить удаленного специалиста, который установит кнопку на ваш сайт. <br>
              Стоимость услуги- 1500 рублей.<br>
              Чтобы воспользоваться услугой- напишите в чат службы поддержки.
            </p>
            <p>
              Внимание! В услуге может быть отказано, если будет выявлено,<br>
              что отсутствует данная техническая возможность. <br>
              Срок выполнения услуги от 2 часов до 1 недели<br> 
              (зависит от загруженности, предварительно оговаривается)
            </p>
          </div>
        </div>

        <div class="integrate--lifehack width-100p shadow-card mrg-t-10">
          <div class="text-bold">Инструкция по использованию отдельной ссылки</div>
          <div class="mrg-t-10">
            <p>
              Если вы размещаете ссылку записи онлайн в соц.сетях или вместо 
              интеграции виджета желаете просто создать 
              кнопку-ссылку, которая будет вести на страницу записи онлайн,
              то дадим несколько подсказок:
            </p>
            <p>
              Вы можете использовать некоторые <b>GET-параметры</b> вместе с ссылкой записи онлайн:
            </p>
            <p>
              1. <b>&back_url=</b> - При наличии данного параметра на странице записи будет отображаться кнопка "Закрыть".<br>
              Значением параметра должна служить ссылка на которую вы хотите, чтобы вернулся клиент при нажатии на кнопку.
              Нажимая на нее, клиент будет возвращаться на указанный адрес. 
            </p>
            <p>
              2. <b>&from=</b> - В данный параметр вставляется короткое обозначение источника привлечения на латинице.
              Создать источники привлечения вы можете в разделе "Настройки" -> "Источники привлечения".
              Если параметр задан, то записям и новым клиентам будет автоматически присваиваться соответствующий источник. 
              Если вы не пользуетесь функционалом, то просто не используйте данный параметр.
            </p>
            <p>
              Ссылка на нашу тестовую компанию для примера (как это может выглядеть):<br>
              <a href="https://online.enroller.ru/c/jQu?back_url=https://enroller.ru&from=landing" target="_blank">
                https://online.enroller.ru/c/jQu<b>?back_url=https://enroller.ru&from=landing</b>
              </a>              
            </p>
            <p>
              Для того, чтобы ссылка выглядела не такой длинной, вы можете воспользоваться
              одним из бесплатных сокращателей ссылок в интернете.
            </p>
            <a 
              href="https://yandex.ru/search/?text=сервис+по+сокращению+ссылок" 
              class="btn btn-sm btn-orange"
              target="_blank"
            >
              Найти сокращатель ссылок
            </a>
          </div>
        </div>

        <div class="integrate--insite width-100p shadow-card mrg-t-10">
          <div class="text-bold">Инструкция по интеграции виджета в сайт</div>
          <div class="mrg-t-10">
            <p>
              Воспользуйтесь нашим CDN для подключения библиотек:<br>
              <span class="text-danger text-bold">https://cdn.enroller.ru/libs/enroller-css-1.5.css</span><br>
              <span class="text-danger text-bold">https://cdn.enroller.ru/libs/enroller-js-1.4.js</span>
            </p>
            <p>
              Или скачайте архив с файлами: <a class="text-link" href="https://back.enroller.ru/libs/enroller_lib.zip"><b>enroller_lib.zip</b></a>
            </p>
            <p>
              Распакуйте архив, в нем 2 файла:<br>
              <span class="text-danger">enroller-css-1.5.css</span><br>
              <span class="text-danger">enroller-js-1.4.js</span>
            </p>
            <p>
              <b>Шаг 1:</b> Подключите файл стилей в <span class="text-danger">&lt;head&gt;</span> вашего сайта:<br>
              <span class="text-danger small">&lt;head&gt;</span><br>
              &nbsp; &nbsp; &nbsp; &nbsp; <span class="text-danger small">&lt;link href="путь до файла/enroller-css-1.5.css" type="text/css" rel="stylesheet"&gt;</span><br>
              <span class="text-danger small">&lt;/head&gt;</span>
            </p>
            <p>
              <b>Шаг 2:</b> Подключите файл javascript перед закрывающим тэгом <span class="text-danger">&lt;/body&gt;</span> вашего сайта:<br>
              &nbsp; &nbsp; &nbsp; <span class="text-danger small">&lt;script src="путь до файла/enroller-js-1.4.js"&gt;&lt;/script&gt;</span><br>
              <span class="text-danger small">&lt;/body&gt;</span><br>
              <span class="text-danger small">&lt;/html&gt;</span>
            </p>
            <p>
              <b>Шаг 3:</b> Добавьте кнопку записи онлайн перед тэгом <span class="text-danger">&lt;footer&gt;</span> вашего сайта:<br>
              &nbsp; &nbsp;  &nbsp;<span class="text-danger small">&lt;div <br> 
              <div style="padding-left: 8px;">data-link="ВАША ССЫЛКА НА ЗАПИСЬ ОНЛАЙН"</div> 
              <div style="padding-left: 8px;">data-from="КОРОТКОЕ ОБОЗНАЧЕНИЕ ИСТОЧНИКА ПРИВЛЕЧЕНИЯ"</div> 
              <div style="padding-left: 8px;">class="<span class="text-success">enroller-button enroller-button-main enroller-button--blue enroller--pulse</span>" </div> &gt;
              <div style="padding-left: 8px;">Запись онлайн</div> &lt;/div&gt;</span><br>
              <span class="text-danger small">&lt;footer&gt;</span><br>
            </p>
            <br>
            
            <div>
              <div class="text-bold">Пояснения:</div>
              <p>
                В аттрибут <b class="text-danger">data-link</b> (<b>обязательный!</b>) следует вставлять вашу ссылку на запись 
                онлайн. Вы можете добавлять свои GET-параметры для яндекс.метрики к данной ссылке, но не вставляйте сюда
                наш GET-параметр <b>back_url</b>, т.к он добавляется автоматически.<br>
                Если компаний несколько, то можно вставить общую ссылку 
                (общая ссылка появляется, если у вас более 1 компании).
                Взять ссылку на запись (общую и конкретной компании) можно на текущей странице в самом верху. 
              </p>
              <p>
                В аттрибут <b class="text-danger">data-from</b> (<b>необязательный</b>) вставляется короткое обозначение источника привлечения 
                на латинице. После того, как клиент кликнет на кнопку, аттрибут будет преобразован в GET-параметр <b>&from=</b>. 
                Создать источники привлечения вы можете в разделе "Настройки" -> "Источники привлечения".
                Если аттрибут задан, то записям и новым клиентам будет автоматически присваиваться соответствующий источник. 
                Если вы не пользуетесь функционалом, то просто не используйте данный аттрибут
              </p>
              <p>
              <b>Пример того, как выглядит кнопка тестовой компании на нашем главном сайте https://enroller.ru</b><br>
              &nbsp; &nbsp;  &nbsp;<span class="text-danger small">&lt;div <br> 
              <div style="padding-left: 8px;">data-link="https://online.enroller.ru/c/jQu"</div> 
              <div style="padding-left: 8px;">data-from="landing"</div> 
              <div style="padding-left: 8px;">class="<span class="text-success">enroller-button enroller-button-main enroller-button--purple-gradient enroller--pulse</span>" </div> &gt;
              <div style="padding-left: 8px;">Запись онлайн</div> &lt;/div&gt;</span><br>
              <span class="text-danger small">&lt;footer&gt;</span><br>
            </p>
            </div>
          </div>
        </div>

        <div class="integrate--style width-100p shadow-card mrg-t-10">
          <div class="text-bold">Стилизация кнопки</div>
          <div class="mrg-t-10">
            <p>
              У кнопки есть 5 классов:<br><br>
              <span class="text-success">.enroller-button</span> - класс, на который навешивается событие onclick. Без него не будет появляться окно записи при клике<br>
              <span class="text-success">.enroller-button-main</span> - это базовый класс для кнопки, определяющий ее форму, размер и положение на странице<br>
              <span class="text-success">.enroller-button--blue</span> - класс, который задает кнопке цвет<br>
              <span class="text-success">.enroller--pulse</span> - класс, который делает кнопку пульсирующей<br>
              <span class="text-success">.enroller-button-position--left-middle</span> - класс, который 
              задает кнопке позиционирование (в правом нижнем углу по умолчанию)
            </p>
            <p>
              У кнопки есть 5 позиций. По умолчанию, если не применять позиционный класс, кнопка будет 
              расположена в правом нижнем углу.<br>
              Вы можете изменить позицию, добавив один из следующих классов:<br><br>
              
                <span class="text-success">.enroller-button-position--right-midle</span> - справа по середине экрана<br>
                <span class="text-success">.enroller-button-position--bootom-midle</span> - снизу по середине экрана<br>
                <span class="text-success">.enroller-button-position--left</span> - слева в нижнем углу<br>
                <span class="text-success">.enroller-button-position--left-middle</span> - слева по середине экрана<br>
              
            </p>
            <p>
              На выбор есть несколько цветов кнопки.<br>
              Для этого замените класс <span class="text-success">enroller-button--blue</span>
              на один из ниже перечисленных:<br><br>
              <b><span style="color:#ff0050;">.enroller-button--rose</span><br>
                <span style="color:#3c4959;">.enroller-button--dark-blue</span><br>
                <span style="color:#1f27b9;">.enroller-button--blue</span><br>
                <span style="color:#30b084;">.enroller-button--mint</span><br>
                <span style="color:#f97577;">.enroller-button--orange</span><br>
                <span style="color:#6dd072;">.enroller-button--green</span><br>
                <span style="color:#CF47C0;">.enroller-button--purple</span><br><br>
                <span style="color:#f97577;">.enroller-button--orange-gradient</span><br>
                <span style="color:#ff0050;">.enroller-button--rose-gradient</span><br>
                <span style="color:#42c747;">.enroller-button--green-gradient</span><br>
                <span style="color:#CF47C0;">.enroller-button--purple-gradient</span></b>
            </p>
            <div class="alert alert-info">
              ! Если вам нужно использовать "свои стили" для кнопки или вставить ее в другое место,
              то можете написать свою реализацию CSS-классов, оставив при этом только class=<span class="text-danger">"enroller-button"</span> (на него вешается событие onclick). <br>
              Вы можете не подключать наш CSS-файл и написать полностью свою реализацию стилей, но обращаем ваше внимание, что в нашем 
              .css файле содержится анимация выезда виджета при нажатии. Вы можете просто взять все необходимое для своих 
              стилей из нашего файла и создать свои.  <br><br>
              Файл <span class="text-danger">enroller-js-1.4.js</span> поставляется в несжатом виде (при скачивании библиотеки), 
              вы можете его модифицировать под ваши нужды
            </div>
          </div>
        </div>
  
      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import integrateRepository from "../../repositories/integrate";
import PanelMainTemplate from "@/components/panel/MainTemplate";

export default {
  name: "Support",
  components: {PanelMainTemplate},
  data() {
    return {
      requestCount: 0,
      links: {
        common: null,
        companies: []
      }
    };
  },
  watch: {

  },
  computed: {

  },
  methods: {
    getLinks(){
      this.$store.dispatch("startPreloader");

      integrateRepository.getLinks().then(resp => {
        this.links.common = resp.data.common;
        this.links.companies = resp.data.company;
        this.requestCount++;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    copyText(text){
      navigator.clipboard.writeText(text)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: 'Ссылка скопирована в буфер обмена',
              time: 3,
              color: "success"
            });
          })
          .catch(() => {
            this.$store.dispatch("addNotification", {
              text: 'Ваш браузер не поддерживает копирование',
              time: 3,
              color: "danger"
            });
          });
    },
    CopyToClipboard(containerid) {
      let range;
      if (document.selection) {
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerid));
        range.select().createTextRange();
        document.execCommand("Copy");
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById(containerid));
        window.getSelection().addRange(range);
        document.execCommand("Copy");
        this.$store.dispatch("addNotification", {
          text: 'Текст скопирован в буфер обмена',
          time: 3,
          color: "success"
        });
      }
    },
    diagnostics(id){
      this.$store.dispatch("startPreloader");

      integrateRepository.diagnostics({ company: id }).then(resp => {
        if(resp.data.result === 'ok'){
          this.$store.dispatch("addNotification", {
            text: 'Проблем не обнаружено',
            time: 3,
            color: "success"
          });
        }else if(resp.data.result == 'error'){
          this.$store.dispatch("addNotification", {
            text: resp.data.message,
            time: 8,
            color: "danger"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  metaInfo: {
    title: "Запись Онлайн - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  created() {
    this.getLinks();
  }
};
</script>

<style scoped lang="less">
.integrate--container{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;
  
  .title{
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
.integrate--common{
  .link{
    font-size: 13px;
    text-decoration: underline;
  }
}
.integrate--links{
  .companies{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 8px;

    .item{
      margin-bottom: 10px;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 8px 4px;
      margin-right: 8px;
      font-size: 13px;
      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      flex-direction: row;
      width: 300px;

      .img{
        width: 70px;
        img{
          width: 60px;
        }
      }
      .info{
        width: 230px;

        .link{
          text-decoration: underline;

          .btn{
            margin-top: 5px;
          }
        }
      }
    }
  }
}
@media (max-width: 700px) {
  .integrate--links{

    .companies{
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 8px;

      .item{
        margin-right: 0;
        margin-top: 15px;
      }
    }
  }
}
</style>
